// tslint:disable:max-classes-per-file
var UnflattenedMaterial = /** @class */ (function () {
    function UnflattenedMaterial() {
        this.materials = [];
        this.materialTypes = [];
        this.materialGroups = [];
    }
    return UnflattenedMaterial;
}());
export { UnflattenedMaterial };
